import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import {
  Box,
  Grid,
  Button,
  Typography,
  OutlinedInput,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";
import { Group_Detail, BaseUrl } from "../../services/Url";
import IosShareIcon from "@mui/icons-material/IosShare";
import GroupTabs from "../../features/GroupDetail/GroupTabs";

const GroupDetail = () => {
  const [searchText, setSearchText] = useState();

  const params = useParams();

  const singleDetail = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + Group_Detail + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        setSearchText(responseData.data.group);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //   useEffect(() => {
  //     setTimeout(() => {
  //       singleDetail();
  //     }, 1500);
  //   }, []);

  useEffect(() => {
    singleDetail();
  }, []);

  return (
    <Box
      display="flex"
      className="box-wrapper br-24 table_bx"
      flexDirection="column"
      justifyContent="flex-start"
    >
      <div className="heading-btn_wrapper">
        <h5 className="fz-20 fw-bold">Group Detail</h5>
        {/* <Button className="btn btn-design">Save</Button> */}
      </div>
      <Box className="form_wrapper input_disabled">
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Group Name</Typography>
              <Typography className="text_bx">
                {searchText?.group_name ? searchText?.group_name : ""}
              </Typography>
              {/* <OutlinedInput fullWidth disabled value="danish" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Payment Date</Typography>
              <Typography className="text_bx">
                {searchText?.payment_due_date
                  ? searchText?.payment_due_date
                  : "N/A"}
              </Typography>
              {/* <OutlinedInput fullWidth disabled value="Payment Date" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Members</Typography>
              <Typography className="text_bx">
                {searchText?.participants
                  ? [...new Set(searchText.participants)].length
                  : ""}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="Participant" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Payout Date</Typography>
              <Typography className="text_bx">
                {searchText?.payout_due_date ? searchText?.payout_due_date : "N/A"}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="Payout Date" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Start Date</Typography>
              <Typography className="text_bx">
                {searchText?.start_date
                  ? moment(searchText.start_date).format("DD-MM-YYYY")
                  : ""}
              </Typography>

              {/* <OutlinedInput fullWidth value="Start Date" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">End Date</Typography>
              <Typography className="text_bx">
                {searchText?.end_date
                  ? moment(searchText.end_date).format("DD-MM-YYYY")
                  : ""}
              </Typography>
              {/* <OutlinedInput fullWidth disabled value="End Date" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Group Created Date</Typography>
              <Typography className="text_bx">
                {searchText?.createdAt
                  ? moment(searchText.createdAt).format("DD-MM-YYYY")
                  : ""}
              </Typography>
              {/* <OutlinedInput fullWidth disabled value="Group Created Date" /> */}
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Currency</Typography>
              <Typography className="text_bx">
                {searchText
                  ? searchText?.currency
                  : ""}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="POT Total" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Duration</Typography>
              <Typography className="text_bx">
                {searchText
                  ? searchText?.frequency_payment
                  : ""}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="POT Total" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Payment Amount</Typography>
              <Typography className="text_bx">
                {searchText
                  ? searchText?.payment_amount
                  : ""}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="POT Total" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Total Pots</Typography>
              <Typography className="text_bx">
                {searchText?.participants
                  ? searchText?.participants.length
                  : ""}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="POT Total" /> */}
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="inpt_bx">
              <Typography variant="h6">Loss Recovery</Typography>
              <Typography className="text_bx">
                {searchText?.loss_recovery ? searchText?.loss_recovery : ""}
              </Typography>

              {/* <OutlinedInput fullWidth disabled value="Loss Recovery" /> */}
            </Box>
          </Grid>
          {searchText?.loss_recovery === 'Commission Percentage' ?
            <><Grid item xs={6}>
              <Box className="inpt_bx">
                <Typography variant="h6">Commission Percentage</Typography>
                <Typography className="text_bx">
                  {searchText?.loss_percentage ? searchText?.loss_percentage : ""}
                </Typography>
                {/* <OutlinedInput fullWidth disabled value="Commission Percentage" /> */}
              </Box>
            </Grid>
              <Grid item xs={6}>
                <Box className="inpt_bx">
                  <Typography variant="h6">Commission Amount</Typography>

                  <Typography className="text_bx">
                    {searchText?.commission_usd ? searchText?.commission_usd : ""}
                  </Typography>

                  {/* <OutlinedInput fullWidth disabled value="Commission Amount" /> */}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className="inpt_bx">
                  <Typography variant="h6">
                    {" "}
                    Pot Total(Excluding Commission)
                  </Typography>
                  <Typography className="text_bx">
                    {searchText?.total_usd ? searchText?.total_usd : ""}
                  </Typography>
                  {/* <OutlinedInput
                fullWidth
                disabled
                value="Pot Total(Excluding Commission)"
              /> */}
                </Box>
              </Grid></> : ''}
        </Grid>
      </Box>
      <Box sx={{ mt: 8 }}>
        <GroupTabs />
      </Box>
    </Box>
  );
};

export default GroupDetail;
